import { render } from "./ProyectoContactoRolForm.vue?vue&type=template&id=65a4aeba&scoped=true"
import script from "./ProyectoContactoRolForm.vue?vue&type=script&lang=js"
export * from "./ProyectoContactoRolForm.vue?vue&type=script&lang=js"

import "./ProyectoContactoRolForm.vue?vue&type=style&index=0&id=65a4aeba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a4aeba"]])

export default __exports__